import { API } from '@config';
import { AboutUsEngineeringTable } from '@src/types/AboutUsEngineerings';

export const getAboutUsEngineering = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/about-us-engineerings?populate=File&sort=id%3Adesc`, options);
  const data: AboutUsEngineeringTable = await response.json();

  return data;
};
